import {
  FACTURE_ETAT,
  SOUS_TYPE_ACOMPTE,
  SOUS_TYPE_AVOIR,
  SOUS_TYPE_AVOIR_SUR_ACOMPTE,
} from '@/configuration/facture/factureConf';
import {
  createTabFilAriane, getLibelleEtatDevisCommandeFacture,
  updateObjectFilAriane, setInfoDevisWithCommandeOrAcompte,
  createObjectArianeEmpty, getToolTipSignatureInfo,
} from '@/services/dcf/detail/filAriane/utilsFunctionsFilAriane';
import {
  DEVIS_COMMANDE_ETAT,
  ETAT_ANNULER,
  TYPE_COMMANDE,
  SENS_ACHAT,
  TYPE_DEVIS,
} from '@/configuration/devisConf';
import { get as getCommande } from '@/api/commande';
import { get as getFacture } from '@/api/facture';

async function createTabFilArianeFacture(facture, isVenteInterne) {
  const tabFilAriane = createTabFilAriane();
  const customClassMarker = facture.etat === ETAT_ANNULER ? 'is-danger has-text-danger' : null;
  const icon = facture.etat === ETAT_ANNULER ? 'close-thick' : null;
  updateObjectFilAriane(tabFilAriane[2], tabFilAriane[2].libelle, null, null,
    true, customClassMarker, getLibelleEtatDevisCommandeFacture(facture.etat, FACTURE_ETAT), icon);
  if (facture.referenceId && facture.reference.type === TYPE_COMMANDE) {
    const commande = (await getCommande(facture.referenceId)).data.result;
    const toolTipSignatureInfo = await getToolTipSignatureInfo(commande.id);
    let routeNameLink = 'c.bodac.commandes';
    if (isVenteInterne) routeNameLink = facture.sens === SENS_ACHAT ? 'c.bodac.commandes-achatVenteInterne' : 'c.bodac.commandes-venteInterne';
    updateObjectFilAriane(tabFilAriane[1], tabFilAriane[1].libelle, routeNameLink, { id: commande.id }, true, null, getLibelleEtatDevisCommandeFacture(commande.etat, DEVIS_COMMANDE_ETAT), 'check-bold',
      null, null, toolTipSignatureInfo);
    await setInfoDevisWithCommandeOrAcompte(commande, tabFilAriane);
  } else if (facture.references && facture.references.length > 0) {
    const idsCommande = facture.references.map(ref => ref.id);
    updateObjectFilAriane(tabFilAriane[0], tabFilAriane[0].libelle, null, null, false, 'steps-marker-notActive', null, null, 'notActive');
    updateObjectFilAriane(tabFilAriane[1], 'detailCommande.multiTypeCommande', 'l.bodac.commandes-listeReferences', { idsCommande: JSON.stringify(idsCommande), idFacture: facture.id }, true, null, null, 'check-bold', null, { nb: idsCommande.length });
  } else if (!facture.referenceId) {
    updateObjectFilAriane(tabFilAriane[0], tabFilAriane[0].libelle, null, null, false, 'steps-marker-notActive', null, null, 'notActive');
    updateObjectFilAriane(tabFilAriane[1], tabFilAriane[1].libelle, null, null, false, 'steps-marker-notActive', null, null, 'notActive');
  }
  return tabFilAriane;
}

async function createTabFilArianeAcompte(acompte) {
  const tabFilAriane = await createTabFilArianeFacture(acompte);
  tabFilAriane[2].libelle = 'detailFacture.sousTypeAcompte';
  if (acompte.reference.type === TYPE_DEVIS) {
    updateObjectFilAriane(tabFilAriane[1], tabFilAriane[1].libelle, null, null, false, 'steps-marker-notActive');
    await setInfoDevisWithCommandeOrAcompte(acompte, tabFilAriane);
  }
  return tabFilAriane;
}

async function createTabFilArianeAvoir(avoir, isVenteInterne) {
  // cas des avoir libre
  if (!avoir.referenceId) {
    const avoirLibreAriane = createTabFilAriane();
    updateObjectFilAriane(avoirLibreAriane[0], avoirLibreAriane[0].libelle, null, null, false, 'steps-marker-notActive', null, null, 'notActive');
    avoirLibreAriane.push(createObjectArianeEmpty('detailFacture.sousTypeAvoir'));
    updateObjectFilAriane(avoirLibreAriane[3], avoirLibreAriane[3].libelle, null, null, false, 'check-bold', getLibelleEtatDevisCommandeFacture(avoir.etat, FACTURE_ETAT), null, 'notActive');
    return avoirLibreAriane;
  }
  const facture = (await getFacture(avoir.referenceId)).data.result;
  const tabFilAriane = await createTabFilArianeFacture(facture);
  const iconObjectFilArianeFacture = tabFilAriane[2].icon ? tabFilAriane[2].icon : 'check-bold';
  let routeNameLink = 'c.bodac.factures';
  if (isVenteInterne) routeNameLink = avoir.SENS_ACHAT ? 'c.bodac.factures-achatVenteInterne' : 'c.bodac.factures-venteInterne';
  updateObjectFilAriane(
    tabFilAriane[2], tabFilAriane[2].libelle, routeNameLink, { id: facture.id },
    true, tabFilAriane[2].customClassMarker,
    tabFilAriane[2].sousLibelle, iconObjectFilArianeFacture,
  );
  tabFilAriane.push(createObjectArianeEmpty('detailFacture.sousTypeAvoir'));
  const customClassMarker = avoir.etat === ETAT_ANNULER ? 'is-danger has-text-danger' : null;
  const icon = avoir.etat === ETAT_ANNULER ? 'close-thick' : null;
  updateObjectFilAriane(tabFilAriane[3], tabFilAriane[3].libelle, null, null,
    true, customClassMarker,
    getLibelleEtatDevisCommandeFacture(avoir.etat, FACTURE_ETAT), icon);
  return tabFilAriane;
}

export default async function createFilArianeFacture(facture, isVenteInterne) {
  let tabFilAriane = [];
  switch (facture.sousType) {
    case SOUS_TYPE_AVOIR:
    case SOUS_TYPE_AVOIR_SUR_ACOMPTE:
      tabFilAriane = await createTabFilArianeAvoir(facture, isVenteInterne);
      break;
    case SOUS_TYPE_ACOMPTE:
      tabFilAriane = await createTabFilArianeAcompte(facture);
      break;
    default:
      tabFilAriane = await createTabFilArianeFacture(facture, isVenteInterne);
      break;
  }
  return tabFilAriane;
}
